import { useQueryWithBoundary } from '@/shared/lib/query';
import { monitoringKeys } from '@/shared/lib/query/queryKeys';

import { GPU_METRICS_CONFIG } from '@/features/monitoring/api/constants';

export function createGpuMetricHook<T>(queryKeyPrefix: string, queryFn: (hostname: string) => Promise<T>) {
  return (hostname: string, enabled: boolean = true) => {
    return useQueryWithBoundary({
      queryKey: monitoringKeys.gpuMetric(queryKeyPrefix, hostname),
      queryFn: () => queryFn(hostname),
      enabled: enabled && !!hostname,
      staleTime: GPU_METRICS_CONFIG.STALE_TIME,
      refetchInterval: enabled && hostname ? GPU_METRICS_CONFIG.REFETCH_INTERVAL : false,
      retry: GPU_METRICS_CONFIG.RETRY_COUNT,
      placeholderData: undefined,
    });
  };
}
